import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

import {
  CarouselContainer,
  StyledContentContainer,
} from "@faire/retailer/components/GiftGuide/GiftGuideTopCarousel";
import { TestimonialCarousel } from "@faire/retailer/components/TestimonialCarousel";
import { Container as MarketplaceProductContainer } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/Container";

export const SearchListWrapper = styled.div<{ $columns: number }>`
  display: grid;
  margin: 8px 0;
  row-gap: 8px;
  column-gap: 8px;

  ${responsiveMediaQueries.tabletAndAbove} {
    column-gap: 16px;
  }

  ${({ $columns }) =>
    css`
      grid-template-columns: [start] repeat(${$columns}, minmax(0, 1fr)) [end];
    `}
`;
export const TileWrapper = styled(Column)`
  ${MarketplaceProductContainer} {
    flex-grow: 1;
  }
`;
export const GiftGuideTopCarouselWrapper = styled.div`
  & ${CarouselContainer} {
    padding: 0;

    ${responsiveMediaQueries.desktopAndAbove} {
      padding: ${getSpacing(0, "7x")};
    }
  }

  & ${StyledContentContainer} {
    padding: ${getSpacing("4x", "3x", "3x")};

    ${responsiveMediaQueries.desktopAndAbove} {
      padding: ${getSpacing("4x", "7x", "3x")};
    }
  }
`;

export const StyledTestimonialCarousel = styled(TestimonialCarousel)`
  padding: ${getSpacing("5x", 0)};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("7x", 0)};
  }
`;

export const OuterResultsContentWrapper = styled.div`
  padding-bottom: ${getSpacing("6x")};
  position: relative;
  left: 0;
  width: 100%;
  min-height: calc(100vh);

  & > :not(${GiftGuideTopCarouselWrapper}, ${StyledTestimonialCarousel}) {
    max-width: 1280px;
    margin: auto;

    padding-left: ${getSpacing("2x")};
    padding-right: ${getSpacing("2x")};
  }
`;
